import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { Cookie, Settings2 } from 'lucide-react';
import CookiePreferencesModal from '@/components/layout/CookiePreferencesModal';

const CookieConsentBanner = ({ onAcceptAll, onRejectAll, onSavePreferences, initialPreferences }) => {
  const [showPreferencesModal, setShowPreferencesModal] = useState(false);

  return (
    <>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 100, damping: 20 }}
        className="fixed bottom-0 left-0 right-0 z-[100] bg-card border-t border-border p-4 shadow-2xl"
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start text-sm text-foreground">
            <Cookie className="h-6 w-6 mr-3 text-primary flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold">We Value Your Privacy</p>
              <p>
                This website uses cookies to ensure you get the best experience.
                <Link to="/cookies" className="text-primary hover:underline ml-1 font-medium" aria-label="Learn more about our cookie policy">
                  Learn More
                </Link>
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button
              onClick={() => setShowPreferencesModal(true)}
              variant="outline"
              className="w-full sm:w-auto border-primary text-primary hover:bg-primary/10"
              aria-label="Open cookie preferences modal"
            >
              <Settings2 className="h-4 w-4 mr-2" />
              Preferences
            </Button>
            <Button
              onClick={onRejectAll}
              variant="outline"
              className="w-full sm:w-auto border-destructive text-destructive hover:bg-destructive/10"
              aria-label="Reject all non-essential cookies"
            >
              Reject All
            </Button>
            <Button
              onClick={onAcceptAll}
              className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90"
              aria-label="Accept all cookies"
            >
              Accept All
            </Button>
          </div>
        </div>
      </motion.div>
      <CookiePreferencesModal
        isOpen={showPreferencesModal}
        onClose={() => setShowPreferencesModal(false)}
        onSave={onSavePreferences}
        initialPreferences={initialPreferences}
      />
    </>
  );
};

export default CookieConsentBanner;